import { App } from "vue"
import permissionDirective from "./permission/index"

const setupDirective = (app: App) => {
  // dom级别权限指令
  app.use(permissionDirective)
}

export default setupDirective
